import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";

/* =========================
SCROLL TOP
========================= */

import ScrollToTop from "./Client/Pages/ScrollToTop";

/* =========================
CLIENT IMPORTS
========================= */

import Navbar from "./Client/Layouts/Navbar";
import Footer from "./Client/Layouts/Footer";

import Home from "./Client/Pages/Home";
import AboutUs from "./Client/Pages/About";
import Membership from "./Client/Pages/Membership";
import Loan from "./Client/Pages/Loan";
import Insurance from "./Client/Pages/Insurance";
import Join from "./Client/Pages/Join";
import Gallery from "./Client/Pages/Gallery";
import Services from "./Client/Pages/Service";

/* =========================
ADMIN IMPORTS
========================= */

import Sidebar from "./vaibhavlaxmiMyAdmin/Layouts/Sidebar";
import Header from "./vaibhavlaxmiMyAdmin/Layouts/Header";

import Dashboard from "./vaibhavlaxmiMyAdmin/Pages/Dashboard";
import Aboutus from "./vaibhavlaxmiMyAdmin/Pages/Aboutus";
import Contactus from "./vaibhavlaxmiMyAdmin/Pages/Contactus";
import Contactinfo from "./vaibhavlaxmiMyAdmin/Pages/Contactinfo";
import Team from "./vaibhavlaxmiMyAdmin/Pages/Team";
import ServicesAdmin from "./vaibhavlaxmiMyAdmin/Pages/Services";
import Activities from "./vaibhavlaxmiMyAdmin/Pages/Activites";
import Holidays from "./vaibhavlaxmiMyAdmin/Pages/Holiday";
import News from "./vaibhavlaxmiMyAdmin/Pages/News";
import Logout from "./vaibhavlaxmiMyAdmin/Pages/Logout";
import Login from "./vaibhavlaxmiMyAdmin/Pages/Login";
import ForgotPassword from "./vaibhavlaxmiMyAdmin/Pages/ForgotPassword";
import PrivateRoute from "./vaibhavlaxmiMyAdmin/Pages/PrivateRoute";

/* =========================
CLIENT CSS
========================= */

import "./Client/Styles/Navbar.css";
import "./Client/Styles/Footer.css";
import "./Client/Styles/Home.css";
import "./Client/Styles/Aboutus.css";
import "./Client/Styles/MemberShip.css";
import "./Client/Styles/Loan.css";
import "./Client/Styles/insourance.css";
import "./Client/Styles/Join.css";
import "./Client/Styles/Gallery.css";
import "./Client/Styles/Services.css";
import "./Client/Styles/themes.css";

/* =========================
ADMIN CSS
========================= */

import "./vaibhavlaxmiMyAdmin/Styles/themes.css";
import "./vaibhavlaxmiMyAdmin/Styles/Sidebar.css";
import "./vaibhavlaxmiMyAdmin/Styles/Header.css";
import "./vaibhavlaxmiMyAdmin/Styles/Aboutus.css";
import "./vaibhavlaxmiMyAdmin/Styles/Contactus.css";
import "./vaibhavlaxmiMyAdmin/Styles/contactinfo.css";
import "./vaibhavlaxmiMyAdmin/Styles/team.css";
import "./vaibhavlaxmiMyAdmin/Styles/Services.css";
import "./vaibhavlaxmiMyAdmin/Styles/Dashboard.css";
import "./vaibhavlaxmiMyAdmin/Styles/Activities.css";
import "./vaibhavlaxmiMyAdmin/Styles/Logout.css";
import "./vaibhavlaxmiMyAdmin/Styles/Login.css";
import "./vaibhavlaxmiMyAdmin/Styles/Holiday.css";
import "./vaibhavlaxmiMyAdmin/Styles/news.css";
import "./vaibhavlaxmiMyAdmin/Styles/forgotPassword.css";

/* =========================
LAYOUT COMPONENT
========================= */

function Layout() {
  const location = useLocation();

  // Check admin routes
  const isAdminRoute = location.pathname.startsWith("/vaibhavlaxmiMyAdmin");

  // Hide sidebar/header/content on login pages
  const hideAdminLayout =
    location.pathname === "/vaibhavlaxmiMyAdmin/login" ||
    location.pathname === "/vaibhavlaxmiMyAdmin/forgot-password";

  return (
    <div>
      <ScrollToTop />

      {/* =========================
CLIENT NAVBAR
========================= */}

      {!isAdminRoute && <Navbar />}

      {/* =========================
ADMIN LAYOUT
========================= */}

      <div className={isAdminRoute ? "admin-layout" : "client-layout"}>
        {isAdminRoute && !hideAdminLayout && <Sidebar />}

        <div className={isAdminRoute ? "main" : ""}>
          {isAdminRoute && !hideAdminLayout && <Header />}

          {/* Content Wrapper */}
          <div className={isAdminRoute && !hideAdminLayout ? "content" : ""}>
            <Routes>
              {/* =========================
CLIENT ROUTES
========================= */}

              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Home />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/loans" element={<Loan />} />
              <Route path="/insurance" element={<Insurance />} />
              <Route path="/join" element={<Join />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/service" element={<Services />} />

              {/* =========================
ADMIN PUBLIC ROUTES
========================= */}

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin"
                element={<Navigate to="/vaibhavlaxmiMyAdmin/login" />}
              />

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin/login"
                element={<Login />}
              />

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin/forgot-password"
                element={<ForgotPassword />}
              />

              {/* =========================
ADMIN PROTECTED ROUTES
========================= */}

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin/dashboard"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin/about"
                element={
                  <PrivateRoute>
                    <Aboutus />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin/contactus"
                element={
                  <PrivateRoute>
                    <Contactus />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin/contactinfo"
                element={
                  <PrivateRoute>
                    <Contactinfo />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin/team"
                element={
                  <PrivateRoute>
                    <Team />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin/services"
                element={
                  <PrivateRoute>
                    <ServicesAdmin />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin/activities"
                element={
                  <PrivateRoute>
                    <Activities />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin/holiday"
                element={
                  <PrivateRoute>
                    <Holidays />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin/news"
                element={
                  <PrivateRoute>
                    <News />
                  </PrivateRoute>
                }
              />

              <Route
                caseSensitive
                path="/vaibhavlaxmiMyAdmin/logout"
                element={
                  <PrivateRoute>
                    <Logout />
                  </PrivateRoute>
                }
              />
            </Routes>
          </div>
        </div>
      </div>

      {/* =========================
CLIENT FOOTER
========================= */}

      {!isAdminRoute && <Footer />}
    </div>
  );
}

/* =========================
APP MAIN
========================= */

export default function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}
